// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"710":"150b2787","871":"df16030a","932":"45582dac","970":"bcb5f5e8"}[chunkId] + ".chunk.js";
};